import { FC } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { ConfirmComponentProps } from '../useConfirmBase';

type ConfirmDialogProps = ConfirmComponentProps & {
  dialogTitle?: string;
  loading?: boolean;
};

const ConfirmDialog: FC<ConfirmDialogProps> = ({
  children,
  dialogTitle,
  open: isOpen,
  loading,
  onCancel,
  prompt,
}) => (
  <Dialog fullWidth maxWidth='sm' onClose={loading ? undefined : onCancel} open={isOpen}>
    {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
    <DialogContent>{prompt}</DialogContent>
    <DialogActions>{children}</DialogActions>
  </Dialog>
);

export default ConfirmDialog;
